import { UcoastEl } from '@/scripts/core/UcoastEl'
import {
    currentTargetRequired,
    getAttributeOrThrow,
    qsaRequired, qsRequired,
    removeTrapFocus,
    trapFocus
} from "@/scripts/core/global";

export class BasicTabs extends UcoastEl {
    static htmlSelector = 'basic-tabs'
    tabOpeners: NodeListOf<HTMLButtonElement>
    tabs: NodeListOf<HTMLElement>
    tabContainer: HTMLElement
    activeIndex = 0
    constructor() {
        super();
        this.tabOpeners = qsaRequired('[data-uc-basic-tab-opener]', this)
        this.tabs = qsaRequired('[data-uc-basic-tab]', this)
        this.tabContainer = qsRequired('[data-uc-basic-tab-container]', this)
    }

    override connectedCallback() {
        super.connectedCallback();
        this.tabOpeners.forEach((opener) => {
            opener.addEventListener('click', this.open.bind(this))
        })
    }

    override disconnectedCallback() {
        super.disconnectedCallback();
        this.tabOpeners.forEach((opener) => {
            opener.removeEventListener('click', this.open.bind(this))
        })
    }

    open(event: Event) {
        const currentTarget = currentTargetRequired(event)
        removeTrapFocus()
        this.activeIndex = parseInt(getAttributeOrThrow('data-uc-basic-tab-opener', currentTarget))
        this.tabOpeners.forEach((opener) => {
            const i = parseInt(getAttributeOrThrow('data-uc-basic-tab-opener', opener))
            if (i === this.activeIndex) {
                opener.setAttribute('aria-expanded', 'true')
            } else {
                opener.setAttribute('aria-expanded', 'false')
            }
        })
        this.tabs.forEach((tab) => {
            const i = parseInt(getAttributeOrThrow('data-uc-basic-tab', tab))
          if (i === this.activeIndex) {
              tab.setAttribute('aria-hidden', 'false')
              this.tabContainer.style.minHeight = `${tab.scrollHeight}px`
          } else {
                tab.setAttribute('aria-hidden', 'true')
          }
        })
        trapFocus(this.tabs[this.activeIndex], this.tabOpeners[this.activeIndex])
    }

}
